import { PublishedLocale } from '@core/internationalize/models/path';

const localePrefixes: readonly string[] = Object.values(PublishedLocale);

export const stripLocalePrefix = (pathname: string): string => {
  const localePrefix = localePrefixes.find(
    locale => pathname === `/${locale}` || pathname.startsWith(`/${locale}/`),
  );
  if (!localePrefix) {
    return pathname;
  }
  return pathname.slice(`/${localePrefix}`.length) || '/';
};

export const matchesAnyPath = (pathname: string, paths: readonly string[]): boolean => {
  if (paths.length === 0) {
    return false;
  }
  const stripped = stripLocalePrefix(pathname);
  return paths.some(path => stripped === path || stripped.startsWith(`${path}/`));
};
